define('modules/navigation/nav_item_model',['backbone'], function(Backbone) {
   'use strict';
    var Item = Backbone.Model.extend({
      defaults: {
        active: false,
        label: '',
        uri: '',
        icon: null,
        button: false,
        badge: false,
        count: 0
      }
    });

    return Item;
});
